import {error} from "services-comun/modules/browser/log";

import {Controller} from "../controller";
import {EncuestasWebFrontendRequest} from "services-comun-ed/modules/services/encuestas/frontend-web";

export class EncuestaController extends Controller {
    /* STATIC */
    public static override async build(): Promise<void> {
        const form = document.getElementById("encuesta") as HTMLFormElement|null;
        if (form!=null) {
            new this(form);
        }
    }

    /* INSTANCE */
    private readonly enviar: HTMLButtonElement|null;

    private constructor(private readonly form: HTMLFormElement) {
        super();

        this.enviar = this.form.getElementsByTagName("button").item(0);
        const opciones = this.form.getElementsByClassName("opcion") as HTMLCollectionOf<HTMLInputElement>;
        for (let i = 0, len = opciones.length; i < len; i++) {
            const opcion = opciones.item(i);
            if (opcion != null) {
                opcion.onclick = () => {
                    this.disableSend(false);
                };
            }
        }
        this.form.onsubmit = (ev) => {
            ev.preventDefault();
            this.summit()
                .then(()=>{})
                .catch((err)=>{
                    error(err);
                });
        };
    }

    private disableSend(enable: boolean): void {
        requestAnimationFrame(()=>{
            if (this.enviar!=null) {
                this.enviar.disabled = enable;
            }
        });
    }

    private async summit(): Promise<void> {
        const formData = new FormData(this.form);
        const encuesta = parseInt(formData.get("encuesta") as string);
        const opcion = formData.get("opcion") as string;
        if (encuesta!=null && opcion!=null) {
            this.disableSend(true);
            const respuesta = await EncuestasWebFrontendRequest.votar(encuesta, opcion);
            const opciones = respuesta.opciones;
            const inputs = this.form.getElementsByClassName("pintar") as HTMLCollectionOf<HTMLDivElement>;
            const textos = this.form.getElementsByClassName("resultado-texto") as HTMLCollectionOf<HTMLDivElement>;
            if (inputs.length==opciones.length && textos.length==opciones.length) {
                requestAnimationFrame(()=>{
                    for (let i=0, len=inputs.length; i<len; i++) {
                        const input = inputs.item(i);
                        const texto = textos.item(i);
                        if (input!=null && texto!=null) {
                            const porcentaje = opciones[i].porcentaje;
                            input.style.width = `${porcentaje}%`;
                            texto.innerText = `${porcentaje}%`;
                        }
                    }
                    this.form.reset();
                });
            } else {
                window.location.reload();
            }
        }
    }
}
